import Icon from '../components/Icon.vue'

Icon.register({"arrow-down":{"width":1664,"height":1792,"paths":[{"d":"M1611 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37l-651-652q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294v-704q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-down.js
// module id = 1156
// module chunks = 0